import React,{ Component } from 'react';
import ArticleCreateContainer from './container/ArticleCreateContainer';

export default class ArticleCreate extends Component{
    componentDidMount() {
        window.scrollTo(0,0)
    }
    render(){

        return(
            <React.Fragment>
                <ArticleCreateContainer {...this.props} />
            </React.Fragment>

        )
    }
}
